import * as React from 'react';

import { CardContainerStyle } from './SectionArticles';
import { NewsCard } from './NewsCard';
import { Container } from './Container';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { ALL_NEWS_QUERY } from '../../../client/__graphql__/queries/getAllNews';
import { IsValidUrl } from '../../utils/helpers/url';
import {
  NewsType,
  NewsSearchTypes,
} from '../../../client/types/generated/types';

export const SectionNewsCard: React.FC<{
  style?: any;
  searchType?: NewsSearchTypes;
  limit?: number
}> = ({ style, searchType, limit }) => {
  const params = useParams<{ urltag: string }>();
  const { data, error, loading } = useQuery(ALL_NEWS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      input: {
        urltag: params?.urltag ? params.urltag : '',
        type: NewsType.Nybyggportal,
        searchType: searchType,
        published: true,
        active: 1,
        page: 0,
        limit: (limit ? limit : 3),
      },
    },
  });

  const GetUrl = (item: any) => {
    if (item) {
      if (IsValidUrl(item?.externalUrl)) {
        return item?.externalUrl;
      }

      if (item?.slug) {
        if (params?.urltag || item?.officetag) {
          return `/kontor/${!item?.officetag ? params?.urltag : item?.officetag}/artikkel/${item.slug}`;
        }
        return `/artikkel/${item.slug}`;
      }
    }

    return '';
  }

  return (
    <Container style={style}>
      <CardContainerStyle>
        {data?.getAllNews?.list?.map((item: any, index: any) => (
          <NewsCard
            key={item.id}
            id={item.id}
            title={item.title}
            ingress={item.ingress}
            image={item.image}
            newTab={false}
            url={GetUrl(item)}
          />
        ))}
      </CardContainerStyle>
    </Container>
  );
};
